import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../nodeIds';

export const disability: AnswerPathTreeNode = { path: 'disability', nodeId: NodeIds.insuredDisability };
